export async function copyAsPlainText(text: string, author?: string): Promise<boolean> {
  const content = `"${text}" — ${author || 'Unknown'}`;
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch {
    return false;
  }
}

export async function copyAsMarkdown(text: string, author?: string, url?: string): Promise<boolean> {
  let content = `> "${text}"\n>\n> — *${author || 'Unknown'}*`;
  if (url) content += `\n\n[Source](${url})`;
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch {
    return false;
  }
}

export async function copyAsHTML(text: string, author?: string): Promise<boolean> {
  const content = `<blockquote><p>"${text}"</p>${author ? `<footer>— ${author}</footer>` : ''}</blockquote>`;
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch {
    return false;
  }
}
